import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alm-items-name-wrapper" }
const _hoisted_2 = { class: "items-value-span" }
const _hoisted_3 = { class: "alm-items-subdetails-wrapper" }
const _hoisted_4 = { class: "items-subdetails-value-span" }
const _hoisted_5 = { class: "items-subdetails-value-span" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(`Source: ${_ctx.sourceTenant}`), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "items-divider" }, null, -1)),
      _createElementVNode("span", _hoisted_5, _toDisplayString(`Last deployed: ${_ctx.lastDeployed}`), 1)
    ])
  ]))
}